import { render, staticRenderFns } from "./AMeasureTransitionCommentControl.reg.vue?vue&type=template&id=143c1ae3&scoped=true&"
import script from "./AMeasureTransitionCommentControl.reg.vue?vue&type=script&lang=ts&"
export * from "./AMeasureTransitionCommentControl.reg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143c1ae3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VCardText,VCardTitle,VTextarea})
